import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, Text, ThinCheckIcon } from '@common-fe/common-fe';

const FiledItem = ({ title }: { title: string }) => (
  <Box
    data-testid="document-details-card_field-item"
    margin={{ top: 'spacing2' }}
    direction="row"
    align="center" 
  >
    <ThinCheckIcon size="16px" />
    <Text data-testid="document-details-card_field-item_text">
      {title}
    </Text>
  </Box>
);

const DocumentDetailsCard: React.FC<BoxExtendedProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Box
      data-testid="document-details-card"
      pad={{ horizontal: 'spacing16', vertical: 'spacing12' }}
      round="container1Round"
      background="infoContainer"
      {...props}
    >
      <Text data-testid="document-details-card_title" weight={700}>
        {t('Make sure your document clearly shows the following details:')}
      </Text>
      <Box data-testid="document-details-card_fields" direction="row"  gap="spacing8" wrap>
        <FiledItem title={t('Amount')} />
        <FiledItem title={t('Provider/Merchant')} />
        <FiledItem title={t('Date of Service')} />
        <FiledItem title={t('Service Description')} />
        <FiledItem title={t('Service For (if applicable)')} />
      </Box>
    </Box>
  );
};

export default DocumentDetailsCard;
